import * as types from './mutation-types'

const mutation = {
  [types.SET_SELECTED_STATE_LAW](state, newValue) {
    newValue.disclosure = { 
      json: {
        type: "doc",
        content: [
            {
              type: "paragraph",
              content: [
              {
                  "type": "text",
                  "text": `${newValue.disclosure}`
              }
              ]
            }
        ]
      },
      html:`<p>${newValue.disclosure}</p>`
      , 
      notary: {
        json: {},
        html: ``
      }
    }

    state.selected_statelaws = newValue
  },
  [types.SET_SELECTED_STATE_LAW_DEFAULT](state, selectedState) {
    state.selected_statelaws = state.default_statelaws
    state.selected_statelaws.state = selectedState
  },
  [types.ADD_ALLOWED_ITEMS](state, items) {
    //remove items
      state.selected_statelaws.not_allowed_documents = 
      state.selected_statelaws.not_allowed_documents.filter(value => !items.includes(value));
      //add items
      state.selected_statelaws.allowed_documents.push(...items)
  },
  [types.REMOVE_ALLOWED_ITEMS](state, items) {
    //remove items
      state.selected_statelaws.allowed_documents = 
        state.selected_statelaws.allowed_documents.filter(value => !items.includes(value));
      //add items
      state.selected_statelaws.not_allowed_documents.push(...items)
  },
  [types.ADD_PROOF_ALLOWED_ITEMS](state, items) {
    //remove items
      state.selected_statelaws.not_allowed_proof_id = 
      state.selected_statelaws.not_allowed_proof_id.filter(value => !items.includes(value));
      //add items
      state.selected_statelaws.allowed_proof_id.push(...items)
  },
  [types.REMOVE_PROOF_ALLOWED_ITEMS](state, items) {
    //remove items
      state.selected_statelaws.allowed_proof_id = 
        state.selected_statelaws.allowed_proof_id.filter(value => !items.includes(value));
      //add items
      state.selected_statelaws.not_allowed_proof_id.push(...items)
  }
  
}

export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/statelaws/mutations.js